import { render, staticRenderFns } from "./ProductExerpt.vue?vue&type=template&id=cb3e360a&"
import script from "./ProductExerpt.vue?vue&type=script&lang=js&"
export * from "./ProductExerpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ILocalize: require('/opt/build/repo/components/svg/Localize.vue').default})
